import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class PartyViewPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout {...this.props} mode={ErpScopeMode.None} pages={{ entity: ErpEntities.party(this.props), view: {} }}><></></ErpLayout>
        );
    }
}